export const ROUTES = {
  LOGIN: "/login",
  AUTH_CALLBACK: "/auth/callback",
  LOGOUT: "/logout",
  HOME: "/",
  VENDOR_DASHBOARD: "/vendor/dashboard",
  DAE_DASHBOARD: "/dae/dashboard",
  VENDOR_MANAGEMENT: "/vendors",
  PRINCIPALS: "/principals",
} as const
